import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "detail-panel w-80 bg-white shrink-0 flex flex-col overflow-hidden border-l border-slate-200/60"
};
const _hoisted_2 = {
  class: "panel-header px-4 py-3 border-b border-slate-100/80 flex items-center justify-between shrink-0 bg-white"
};
const _hoisted_3 = {
  class: "panel-body flex-1 overflow-y-auto"
};
const _hoisted_4 = {
  key: 0,
  class: "w-full h-full flex items-center justify-center text-slate-300 p-2"
};
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center text-slate-400 bg-black/5"
};
const _hoisted_7 = ["src", "poster"];
const _hoisted_8 = {
  key: 1,
  class: "flex flex-col items-center px-4 text-center"
};
const _hoisted_9 = {
  class: "text-xs mt-2 text-slate-400"
};
const _hoisted_10 = {
  key: 2,
  class: "flex flex-col items-center text-slate-400"
};
const _hoisted_11 = {
  class: "w-16 h-16 rounded-2xl bg-sky-50 flex items-center justify-center mb-2"
};
const _hoisted_12 = {
  class: "text-xs mt-1 text-slate-600 font-medium"
};
const _hoisted_13 = {
  key: 0,
  class: "text-[10px] text-slate-400 mt-1"
};
const _hoisted_14 = {
  key: 3,
  class: "w-full h-full p-4 overflow-y-auto bg-white"
};
const _hoisted_15 = {
  class: "text-sm text-slate-600 whitespace-pre-wrap leading-relaxed"
};
const _hoisted_16 = {
  class: "info-section px-4 py-4 border-b border-slate-100/60"
};
const _hoisted_17 = {
  class: "text-sm font-semibold text-slate-800 mb-1"
};
const _hoisted_18 = {
  key: 0,
  class: "text-xs text-slate-500 mb-3 leading-relaxed"
};
const _hoisted_19 = {
  class: "flex flex-wrap gap-1.5 mb-3"
};
const _hoisted_20 = {
  key: 0,
  class: "text-[10px] text-slate-300"
};
const _hoisted_21 = {
  class: "text-[11px] text-slate-400 space-y-1.5 bg-slate-50/60 rounded-lg p-2.5"
};
const _hoisted_22 = {
  class: "flex items-center gap-2"
};
const _hoisted_23 = {
  class: "text-slate-600 font-medium"
};
const _hoisted_24 = {
  key: 0,
  class: "flex items-center gap-2"
};
const _hoisted_25 = {
  class: "text-slate-600 font-medium"
};
const _hoisted_26 = {
  key: 1,
  class: "flex items-center gap-2"
};
const _hoisted_27 = {
  class: "text-slate-600 font-medium"
};
const _hoisted_28 = {
  class: "flex items-center gap-2"
};
const _hoisted_29 = {
  class: "text-slate-500"
};
const _hoisted_30 = {
  class: "flex items-center gap-2"
};
const _hoisted_31 = {
  class: "text-slate-500"
};
const _hoisted_32 = {
  class: "flex items-center gap-1 mt-3"
};
const _hoisted_33 = {
  class: "versions-section px-4 py-4"
};
const _hoisted_34 = {
  class: "flex items-center justify-between mb-3"
};
const _hoisted_35 = {
  class: "text-[11px] font-semibold text-slate-400 uppercase tracking-wider"
};
const _hoisted_36 = {
  class: "text-primary-600 font-bold ml-1"
};
const _hoisted_37 = {
  key: 0,
  class: "text-xs text-slate-300 text-center py-6 bg-slate-50/40 rounded-lg"
};
const _hoisted_38 = {
  class: "space-y-2"
};
const _hoisted_39 = {
  class: "flex items-center justify-between mb-1.5"
};
const _hoisted_40 = {
  class: "text-xs font-semibold text-slate-700 flex items-center gap-1.5"
};
const _hoisted_41 = {
  key: 0,
  class: "text-[10px] px-1.5 py-0.5 rounded-md bg-primary-100 text-primary-700 font-medium"
};
const _hoisted_42 = {
  class: "text-[10px] text-slate-400"
};
const _hoisted_43 = {
  key: 0,
  class: "text-[11px] text-slate-500 mb-2 leading-relaxed"
};
const _hoisted_44 = {
  key: 1,
  class: "flex items-center gap-1.5"
};
const _hoisted_45 = ["onClick"];
const _hoisted_46 = {
  key: 0,
  class: "panel-footer px-2 py-2 border-t border-slate-100/80 shrink-0 bg-white"
};
const _hoisted_47 = {
  class: "flex justify-between gap-1"
};
import { computed, ref, watch } from 'vue';
import { Close, VideoPlay, Document, Picture, View, Download, Edit, Right, PriceTag, Delete, Plus } from '@element-plus/icons-vue';
import { previewAsset, downloadAsset } from '@/api/assets';
import FilePreviewModal from '@/components/FilePreviewModal.vue';
export default {
  __name: 'AssetDetailPanel',
  props: {
    asset: {
      type: Object,
      default: null
    },
    versions: {
      type: Array,
      default: () => []
    },
    versionsLoading: {
      type: Boolean,
      default: false
    },
    folderManageable: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'edit', 'delete', 'move', 'tags', 'new-version', 'restore-version'],
  setup(__props) {
    const props = __props;
    const currentVersion = computed(() => {
      return props.versions?.find(v => v.id === props.asset?.currentVersionId) || null;
    });
    const videoPreviewUrl = ref('');
    const videoPreviewLoading = ref(false);
    const previewVisible = ref(false);
    const previewFile = ref(null);
    const textPreview = computed(() => {
      const content = currentVersion.value?.textContent || '';
      return content.length > 500 ? content.substring(0, 500) + '...' : content;
    });
    const previewHeightClass = computed(() => {
      if (props.asset?.type === 'TEXT') return 'h-36';
      if (props.asset?.type === 'VIDEO') return 'h-48';
      return 'h-44';
    });
    watch(() => [props.asset?.id, props.asset?.type], () => {
      loadVideoPreview();
    }, {
      immediate: true
    });
    function typeLabel(type) {
      const map = {
        IMAGE: '图片',
        VIDEO: '视频',
        FILE: '文件',
        TEXT: '文本'
      };
      return map[type] || type;
    }
    function formatFileSize(bytes) {
      if (!bytes) return '';
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / 1048576).toFixed(1) + ' MB';
    }
    function formatTime(time) {
      if (!time) return '';
      return time.replace('T', ' ');
    }
    function openTextContent(content) {
      const blob = new Blob([content || ''], {
        type: 'text/plain;charset=UTF-8'
      });
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
      window.setTimeout(() => URL.revokeObjectURL(url), 30000);
    }
    async function loadVideoPreview() {
      videoPreviewUrl.value = '';
      if (props.asset?.type !== 'VIDEO' || !props.asset?.id) {
        return;
      }
      videoPreviewLoading.value = true;
      try {
        const data = await previewAsset(props.asset.id);
        videoPreviewUrl.value = typeof data === 'string' ? '' : data?.previewUrl || '';
      } finally {
        videoPreviewLoading.value = false;
      }
    }
    async function handleCurrentPreview() {
      const assetType = props.asset?.type;
      // TEXT / VIDEO：通用预览组件不支持，保留原行为
      if (assetType === 'TEXT' || assetType === 'VIDEO') {
        const data = await previewAsset(props.asset.id);
        if (typeof data === 'string') {
          openTextContent(data);
          return;
        }
        if (data?.previewUrl) {
          window.open(data.previewUrl, '_blank');
        }
        return;
      }

      // IMAGE / FILE：使用通用预览组件
      const data = await previewAsset(props.asset.id);
      if (typeof data === 'string') {
        openTextContent(data);
        return;
      }
      if (!data?.previewUrl) return;
      const v = currentVersion.value;
      previewFile.value = {
        url: data.previewUrl,
        name: v?.originalName || props.asset.name,
        originalName: v?.originalName,
        fileName: v?.originalName,
        size: v?.fileSize,
        fileSize: v?.fileSize,
        contentType: v?.contentType
      };
      previewVisible.value = true;
    }
    async function handleCurrentDownload() {
      const data = await downloadAsset(props.asset.id);
      if (typeof data === 'string') {
        openTextContent(data);
        return;
      }
      if (data?.downloadUrl) {
        window.open(data.downloadUrl, '_blank');
      }
    }
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[7] || (_cache[7] = _createElementVNode("span", {
        class: "text-sm font-semibold text-slate-700 truncate"
      }, "素材详情", -1)), _createElementVNode("button", {
        type: "button",
        class: "btn-icon",
        title: "关闭",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('close'))
      }, [_createVNode(_component_el_icon, {
        size: 16
      }, {
        default: _withCtx(() => [_createVNode(_unref(Close))]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: _normalizeClass(["preview-area bg-gradient-to-br from-slate-100 to-slate-50 flex items-center justify-center border-b border-slate-100/60", previewHeightClass.value])
      }, [__props.asset.type === 'IMAGE' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [__props.asset.coverUrl ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: __props.asset.coverUrl,
        alt: __props.asset.name,
        class: "max-w-full max-h-full object-contain rounded shadow-sm"
      }, null, 8, _hoisted_5)) : (_openBlock(), _createBlock(_component_el_icon, {
        key: 1,
        size: 48
      }, {
        default: _withCtx(() => [_createVNode(_unref(Picture))]),
        _: 1
      }))])) : __props.asset.type === 'VIDEO' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [videoPreviewUrl.value ? (_openBlock(), _createElementBlock("video", {
        key: videoPreviewUrl.value,
        src: videoPreviewUrl.value,
        poster: __props.asset.coverUrl || undefined,
        class: "w-full h-full object-contain",
        controls: "",
        preload: "metadata"
      }, " 当前浏览器不支持视频播放 ", 8, _hoisted_7)) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_el_icon, {
        size: 40
      }, {
        default: _withCtx(() => [_createVNode(_unref(VideoPlay))]),
        _: 1
      }), _createElementVNode("span", _hoisted_9, _toDisplayString(videoPreviewLoading.value ? '加载视频预览中' : '暂无可播放预览'), 1)]))])) : __props.asset.type === 'FILE' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_icon, {
        size: 40
      }, {
        default: _withCtx(() => [_createVNode(_unref(Document))]),
        _: 1
      })]), _createElementVNode("span", _hoisted_12, _toDisplayString(currentVersion.value?.originalName || __props.asset.name), 1), currentVersion.value?.fileSize ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(formatFileSize(currentVersion.value.fileSize)), 1)) : _createCommentVNode("", true)])) : __props.asset.type === 'TEXT' ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("p", _hoisted_15, _toDisplayString(textPreview.value), 1)])) : _createCommentVNode("", true)], 2), _createElementVNode("div", _hoisted_16, [_cache[15] || (_cache[15] = _createElementVNode("h4", {
        class: "text-[11px] font-semibold text-slate-400 uppercase tracking-wider mb-3"
      }, "基本信息", -1)), _createElementVNode("p", _hoisted_17, _toDisplayString(__props.asset.name), 1), __props.asset.description ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(__props.asset.description), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.asset.tags, tag => {
        return _openBlock(), _createElementBlock("span", {
          key: tag.id,
          class: "text-[10px] px-2 py-1 rounded-md font-medium",
          style: _normalizeStyle({
            backgroundColor: (tag.color || '#6366f1') + '15',
            color: tag.color || '#6366f1'
          })
        }, _toDisplayString(tag.name), 5);
      }), 128)), !__props.asset.tags?.length ? (_openBlock(), _createElementBlock("span", _hoisted_20, "无标签")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_cache[8] || (_cache[8] = _createElementVNode("span", {
        class: "text-slate-400 w-10 shrink-0"
      }, "类型", -1)), _createElementVNode("span", _hoisted_23, _toDisplayString(typeLabel(__props.asset.type)), 1)]), currentVersion.value?.fileSize ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_cache[9] || (_cache[9] = _createElementVNode("span", {
        class: "text-slate-400 w-10 shrink-0"
      }, "大小", -1)), _createElementVNode("span", _hoisted_25, _toDisplayString(formatFileSize(currentVersion.value.fileSize)), 1)])) : _createCommentVNode("", true), currentVersion.value?.width && currentVersion.value?.height ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_cache[10] || (_cache[10] = _createElementVNode("span", {
        class: "text-slate-400 w-10 shrink-0"
      }, "尺寸", -1)), _createElementVNode("span", _hoisted_27, _toDisplayString(currentVersion.value.width) + " × " + _toDisplayString(currentVersion.value.height), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_28, [_cache[11] || (_cache[11] = _createElementVNode("span", {
        class: "text-slate-400 w-10 shrink-0"
      }, "创建", -1)), _createElementVNode("span", _hoisted_29, _toDisplayString(formatTime(__props.asset.createTime)), 1)]), _createElementVNode("div", _hoisted_30, [_cache[12] || (_cache[12] = _createElementVNode("span", {
        class: "text-slate-400 w-10 shrink-0"
      }, "更新", -1)), _createElementVNode("span", _hoisted_31, _toDisplayString(formatTime(__props.asset.updateTime)), 1)])]), _createElementVNode("div", _hoisted_32, [_createElementVNode("button", {
        type: "button",
        class: "btn-text",
        onClick: handleCurrentPreview
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(View))]),
        _: 1
      }), _cache[13] || (_cache[13] = _createTextVNode("预览 ", -1))]), _createElementVNode("button", {
        type: "button",
        class: "btn-text",
        onClick: handleCurrentDownload
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Download))]),
        _: 1
      }), _cache[14] || (_cache[14] = _createTextVNode("下载 ", -1))])])]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("h4", _hoisted_35, [_cache[16] || (_cache[16] = _createTextVNode(" 版本历史 ", -1)), _createElementVNode("span", _hoisted_36, _toDisplayString(__props.versions.length || 0), 1)]), __props.folderManageable ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "btn-text-primary",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('new-version', __props.asset))
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Plus))]),
        _: 1
      }), _cache[17] || (_cache[17] = _createTextVNode("新增 ", -1))])) : _createCommentVNode("", true)]), !__props.versions.length && !__props.versionsLoading ? (_openBlock(), _createElementBlock("div", _hoisted_37, " 暂无版本记录 ")) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_38, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.versions, v => {
        return _openBlock(), _createElementBlock("div", {
          key: v.id,
          class: _normalizeClass(["version-item rounded-lg p-3 border transition-all duration-150", v.id === __props.asset.currentVersionId ? 'border-primary-200/80 bg-primary-50/30 shadow-sm' : 'border-slate-100 bg-white hover:border-slate-200 hover:shadow-sm'])
        }, [_createElementVNode("div", _hoisted_39, [_createElementVNode("span", _hoisted_40, [_cache[18] || (_cache[18] = _createElementVNode("span", {
          class: "w-5 h-5 rounded bg-slate-100 flex items-center justify-center text-[10px] font-bold text-slate-500"
        }, "v", -1)), _createTextVNode(" " + _toDisplayString(v.versionNo) + " ", 1), v.id === __props.asset.currentVersionId ? (_openBlock(), _createElementBlock("span", _hoisted_41, "当前")) : _createCommentVNode("", true)]), _createElementVNode("span", _hoisted_42, _toDisplayString(formatTime(v.createTime)), 1)]), v.changeRemark ? (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString(v.changeRemark), 1)) : _createCommentVNode("", true), v.id !== __props.asset.currentVersionId && __props.folderManageable ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_createElementVNode("button", {
          type: "button",
          class: "btn-text-primary",
          onClick: $event => _ctx.$emit('restore-version', {
            assetId: __props.asset.id,
            versionId: v.id
          })
        }, " 恢复此版本 ", 8, _hoisted_45)])) : _createCommentVNode("", true)], 2);
      }), 128))])), [[_directive_loading, __props.versionsLoading]])])]), __props.folderManageable ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createElementVNode("button", {
        type: "button",
        class: "btn-secondary btn-sm flex-1",
        onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('edit', __props.asset))
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Edit))]),
        _: 1
      }), _cache[19] || (_cache[19] = _createTextVNode("编辑 ", -1))]), _createElementVNode("button", {
        type: "button",
        class: "btn-secondary btn-sm flex-1",
        onClick: _cache[3] || (_cache[3] = $event => _ctx.$emit('move', __props.asset))
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Right))]),
        _: 1
      }), _cache[20] || (_cache[20] = _createTextVNode("移动 ", -1))]), _createElementVNode("button", {
        type: "button",
        class: "btn-secondary btn-sm flex-1",
        onClick: _cache[4] || (_cache[4] = $event => _ctx.$emit('tags', __props.asset))
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(PriceTag))]),
        _: 1
      }), _cache[21] || (_cache[21] = _createTextVNode("标签 ", -1))]), _createElementVNode("button", {
        type: "button",
        class: "btn-danger btn-sm flex-1",
        onClick: _cache[5] || (_cache[5] = $event => _ctx.$emit('delete', __props.asset))
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Delete))]),
        _: 1
      }), _cache[22] || (_cache[22] = _createTextVNode("删除 ", -1))])])])) : _createCommentVNode("", true), _createVNode(FilePreviewModal, {
        modelValue: previewVisible.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => previewVisible.value = $event),
        file: previewFile.value
      }, null, 8, ["modelValue", "file"])]);
    };
  }
};